import { atom, selector } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

export const csValidTimeVisibleState = atom({
  key: 'csValidTimeVisibleState',
  default: selector({
    key: 'csValidTimeVisibleStateSelector',
    get: () => {
      return getCustomerSettings('csConfig.validTimeVisible');
    }
  })
});